module.exports = __webpack_public_path__ + "static/media/aaron-robb.10156a61.png";